import { faCartShopping } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useShoppingCartsContext } from 'context/ShoppingCartsContext';
import { tss } from 'tss-react';

import useTranslation from 'hooks/useTranslation';

import { RecipeErpViewComponentProps } from '../Index';

interface IProps extends RecipeErpViewComponentProps {}

const Title = ({ state, cart }: IProps) => {
	const { tl, t } = useTranslation();
	const { classes } = useStyles();
	const carts = useShoppingCartsContext();

	if (!state.editMode) {
		return (
			<h1>
				<FontAwesomeIcon icon={faCartShopping} className={classes.icon} />
				{tl(cart.name) ? tl(cart.name) : t('_general:UNKNOWN_TITLE')}
			</h1>
		);
	}

	return (
		<div className={classes.container}>
			<div className="form-group">
				<label htmlFor="name">{t('standingData:NAME')}</label>
				<input
					type="text"
					className="form-control"
					id="name"
					placeholder="..."
					value={tl(cart.name)}
					onChange={(e) => carts.setName(cart.id, e.target.value)}
				/>
			</div>
			<div className="form-group">
				<label htmlFor="description">{t('_general:DESCRIPTION')}</label>
				<textarea
					className="form-control"
					id="description"
					placeholder="..."
					value={tl(cart.description)}
					onChange={(e) => carts.setDescription(cart.id, e.target.value)}
				/>
			</div>
		</div>
	);
};

export const useStyles = tss.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		gap: '10px',
		backgroundColor: '#efefef',
		padding: '15px 15px',
		paddingTop: '10px',
	},
	icon: {
		marginRight: '0.2em',
	},
});

export default Title;
